import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Summary from './Summary';
import SummaryCowork from './SummaryCowork';
import Payment from './Payment';
import axios from 'axios';
import SuccessDialog from './SuccessDialog.js';
import FacturasDialog from './FacturasDialog.js';
import SummaryDomicilio from './SummaryDomicilio.js';
// import moment from 'moment-timezone';

import HelpContainer from '../HelpContainer';
import { trimCard, validateCard } from '../../helpers/card.js';
import ExtendBookModal from '../Reservation/ExtendBookModal.js';
import GoBackButton from '../../components/GoBackButton/index.jsx';
import Dialog from '../../components/Dialog/index.jsx';


let cancelToken;
let state;
let tokenSession;
// 5 miuntes
const FIRST_TIMER = 1000 * 5 * 60;
// 2 minutes
const SECOND_TIMER = 1000 * 2 * 60;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class PaymentContainer extends Component {

    getInitState = () => {
        return {
            cardCvc: "",
            cardMonth: "",
            cardName: "",
            cardNumber: "",
            cardYear: "",
            city: "",
            country: "",
            error: "",
            isPaying: false,
            neighborhood: "",
            paymentDetails: null,
            po: "",
            promocode: "",
            promocodeError: "",
            reservationOccupancy: "",
            reservationTitle: "",
            state: "",
            number: "",
            street: "",
            RoomBook: null,
            CoworkRoom: null,
            email: "",
            name: "",
            lastname: "",
            phone: "",
            sala: null,
            c_key: "",
            i_key: "",
            is_factura: false,
            endDate: null,
            start_day: null,
            duracion: null,
            center: null,
            finsh_day_fomart: null,
            start_day_fomart: null,
            duracion_str: null,
            duracion_hora: null,
            start_data_monday: null,
            finsh_data_monday: null,
            domicilioComercial: null,
            showExtendModal: false,
            showModalBookExpired: false,
        };
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    // componentWillUnmount() {
    //     cancelToken.cancel('Component will unmount.');
    // }

    componentDidMount() {
        this.reload();
        this.timer = setTimeout(() => {
            this.updateTimer()
        }, FIRST_TIMER)
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
        clearTimeout(this.timer);
        if (this.timer2) {
            clearTimeout(this.timer2);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.c_key !== this.state.c_key) {
            window.Conekta.setPublicKey(this.state.c_key);
        }
    }

    reload = () => {
        // OBTNER EL COWORK Y EL CENTRO 
        if (this.props.location.state) {
            // console.log("No deberia entrar aqui nunca")
            if (this.props.location.state.cowork_id) {
                this.getCenter({
                    token_id: this.props.getTokenId(),
                    center_id: this.props.location.state.centro_id
                });

                this.getCowork({
                    token_id: this.props.getTokenId(),
                    token_session: this.props.getTokenSession(),
                    cowrok_id: this.props.location.state.cowork_id
                });
            } else {
                if (this.props.location.state.domicilioComercial) {
                    this.getCenter({
                        token_id: this.props.getTokenId(),
                        center_id: this.props.location.state.centro_id
                    });

                    this.setState({
                        domicilioComercial: this.props.location.state.domicilioComercial,
                        duracion_str: this.props.location.state.duracion_str,
                        finsh_day_fomart: this.props.location.state.finsh_day_fomart,
                        start_day_fomart: this.props.location.state.start_day_fomart,
                        duracion: this.props.location.state.duracion
                    })

                    console.log(this.props.location.state);
                }
            }
        }

        if (this.props.match.params.reservationsid) {
            this.getPaymentData({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });

            this.getBooK({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });

            this.extendReservation({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });
        }
    }

    getTokenParams = () => {
        const number = trimCard(this.state.cardNumber)
        return {
            "card": {
                number,
                "name": this.state.cardName.trim(),
                "exp_year": "20" + this.state.cardYear.trim(),
                "exp_month": this.state.cardMonth.trim(),
                "cvc": this.state.cardCvc.trim(),
                "address": {
                    "street1": this.state.street.trim(),
                    "street2": this.state.neighborhood.trim(),
                    "city": this.state.city.trim(),
                    "state": this.state.state.trim(),
                    "zip": this.state.po.trim(),
                    "country": this.state.country.trim()
                }
            }
        }
    }

    getCowork = (params) => {
        this.props.post_store(
            "/getCowork",
            params,
            (response) => this.didGetCowork(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getCenter = (params) => {
        this.props.post_store(
            "/getCentersByCity",
            params,
            (response) => this.didGetCenter(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getPaymentData = (params) => {
        this.props.post_store(
            "/getPayment",
            params,
            (response) => this.didPaymentData(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getBooK = (params) => {
        this.props.post_store(
            "/getBook",
            params,
            (response) => this.didGetBook(response),
            (error, type, conekta_msj, msg) => this.handleError(msg),
            cancelToken
        );
    }

    extendReservation = (params) => {
        this.props.post_store(
            "/extendReservation",
            params,
            (response) => { },
            (error, type, conekta_msj, msg) => this.handleError(msg),
            cancelToken
        );
    }

    getRoom = (params) => {
        this.props.post_store(
            "/getRoom",
            params,
            (response) => this.didGetSalas(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    payRoom = (params) => {
        this.props.post_store(
            "/payRoom",
            params,
            (response) => this.didPayRoom(response),
            (error, _, conekta_msj, msg) => {
                this.setState({ isPaying: false });
                this.handleError(msg);
            },
            cancelToken,
            ({ data }) => {
                this.setState({ isPaying: false, error: data.msg })
            }
        );
    }

    payCowork = (params) => {
        this.props.post_store(
            "/payCowork",
            params,
            (response) => this.didPayRoom(response),
            (error, _, conekta_msj, msg) => {
                this.setState({ isPaying: false });
                this.handleError(msg);
            },
            cancelToken,
            () => this.setState({ isPaying: false })
        );
    }

    payDomicilio = (params) => {
        this.props.post_store(
            "/payDomicilio",
            params,
            (response) => this.didPayRoom(response),
            (error, _, conekta_msj, msg) => {
                this.setState({ isPaying: false });
                //this.handleError(error);
            },
            cancelToken,
            () => this.setState({ isPaying: false })
        );
    }

    didGetCowork = (response) => {
        this.setState({ cowork: response })
        this.setState({
            duracion_id: this.props.location.state.duracion_id,
            endDate: this.props.location.state.finsh_day,
            start_day: this.props.location.state.start_data,
            duracion: this.props.location.state.duracion,
            finsh_day_fomart: this.props.location.state.finsh_day_fomart,
            start_day_fomart: this.props.location.state.start_day_fomart,
            duracion_str: this.props.location.state.duracion_str,
            duracion_hora: this.props.location.state.duracion_hora
        })
    }

    didGetCenter = (response) => {
        this.setState({
            center: response,
            c_key: response.c_key
        })
    }

    didPaymentData = (response) => {
        this.setState({ paymentDetails: response })
    }

    didGetBook = (response) => {
        this.setState({ RoomBook: response })

        this.getRoom({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            room_id: this.state.RoomBook.sala_id,
            ingles: false,
        });

    }

    handleError = (msg) => {
        console.warn({ msg })
        window.onbeforeunload = null;
        // alert(msg);
        this.setState({ showModalBookExpired: true })
    }

    didGetSalas = (response) => {
        this.setState({
            sala: response,
            c_key: response.conekta_public_key
        })
        if (response.centro_id) {
            this.getCenter({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                center_id: response.centro_id,
            });
        }
    }

    didPayRoom = (response) => {
        $('#btnSuccess').click();
    }

    handleErrorResponse = (error) => {
        console.error({ error });
    }

    handleCardName = (event) => {
        this.setState({ cardName: event.target.value });
    }

    handleCardNumber = (event) => {
        const { isValid, newValue } = validateCard({
            value: event.target.value,
            state: this.state.cardNumber
        })
        if (isValid) {
            this.setState({ cardNumber: newValue });
        }
    }

    handleCardMonth = (event) => {
        this.setState({ cardMonth: event.target.value });
    }

    handleCardYear = (event) => {
        this.setState({ cardYear: event.target.value });
    }

    handleCardCvc = (event) => {
        this.setState({ cardCvc: event.target.value });
    }

    handleStreetChange = (event) => {
        this.setState({ street: event.target.value });
    }

    handleNeighborhoodChange = (event) => {
        this.setState({ neighborhood: event.target.value });
    }

    handlePoChange = (event) => {
        this.setState({ po: event.target.value });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handleStateChange = (event) => {
        this.setState({ state: event.target.value });
    }

    handleCountryChange = (event) => {
        this.setState({ country: event.target.value });
    }

    handleClearError = () => {
        this.setState({ error: "" });
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleReservationTitle = (event) => {
        this.setState({ reservationTitle: event.target.value });
    }

    handleReservationOccupancy = (event) => {
        this.setState({ reservationOccupancy: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }

    handleFacturaChange = (event) => {
        if (this.state.is_factura) {
            this.setState({ is_factura: false });
        } else {
            this.setState({ is_factura: true });
            $('#btnFacturas').click()
        }
    }

    handlePaymentSubmit = (event) => {
        event.preventDefault();
        if (this.state.phone.length !== 10) {
            return null
        }
        if (this.props.location.state) {
            if (this.props.location.state.cowork_id) {
                const params = {
                    name: this.state.name,
                    lastname: this.state.lastname,
                    phone: this.state.phone,
                    email: this.state.email,
                    _isInvoice: this.state.is_factura,
                    start_day: this.state.start_day_fomart,
                    finsh_day: this.state.finsh_day_fomart,
                    duracion: this.state.duracion,
                    duracion_id: this.state.duracion_id,
                    center: this.state.center.id,
                    cowork_id: this.state.cowork.id,
                    razon_social: this.state.center.centro_razonsociale_id,
                    duracion_hora: this.state.duracion_hora,
                    token_id: this.props.getTokenId(),
                    token_session: this.props.getTokenSession()
                };
                const callback = () => { this.handlePaymentCoworkConekta(params); }

                this.setState({ isPaying: true }, callback);
            }
            if (this.props.location.state.domicilioComercial) {
                const params = {
                    center: this.state.center.id,
                    name: this.state.name,
                    lastname: this.state.lastname,
                    phone: this.state.phone,
                    email: this.state.email,
                    _isInvoice: this.state.is_factura,
                    start_day: this.state.start_day_fomart,
                    finsh_day: this.state.finsh_day_fomart,
                    duracion: this.state.duracion_str,
                    duracion_id: this.state.duracion,
                    razon_social: this.state.center.centro_razonsociale_id,
                    token_id: this.props.getTokenId(),
                    token_session: this.props.getTokenSession()
                };
                const callback = () => { this.handlePaymentDomicilioConekta(params); }

                this.setState({ isPaying: true }, callback);
            }
        }

        if (this.props.match.params.reservationsid) {
            const params = {
                email: this.state.email,
                name: this.state.name,
                lastname: this.state.lastname,
                phone: this.state.phone,
                reservation_id: this.props.match.params.reservationsid,
                reservation_occupancy: this.state.reservationOccupancy ? this.state.reservationOccupancy : 1,
                reservation_title: this.state.reservationTitle,
                razon_social: this.state.sala.centro_razonsociale_id,
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession()
            };
            const callback = () => { this.handlePaymentConekta(params); }

            this.setState({ isPaying: true }, callback);
        }
    }

    handlePaymentConekta = (params) => {
        const onSuccess = (token) => this.payRoom(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );

        const onError = (error) => {
            this.setState({
                error: error.message_to_purchaser,
                isPaying: false
            })
        }

        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    handlePaymentCoworkConekta = (params) => {
        const onSuccess = (token) => this.payCowork(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );

        const onError = (error) => this.setState({
            error: error.message_to_purchaser,
            isPaying: false
        });

        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    handlePaymentDomicilioConekta = (params) => {
        const onSuccess = (token) => this.payDomicilio(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );


        const onError = (error) => this.setState({
            error: error.message_to_purchaser,
            isPaying: false
        });

        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    renderPayment = () => {
        return (
            <Payment
                cardMonth={this.state.cardMonth}
                cardName={this.state.cardName}
                cardNumber={this.state.cardNumber}
                cardCvc={this.state.cardCvc}
                cardYear={this.state.cardYear}
                city={this.state.city}
                country={this.state.country}
                error={this.state.error}
                handleCardCvc={this.handleCardCvc}
                handleCardMonth={this.handleCardMonth}
                handleCardName={this.handleCardName}
                handleCardNumber={this.handleCardNumber}
                handleCardYear={this.handleCardYear}
                handleCityChange={this.handleCityChange}
                handleClearError={this.handleClearError}
                handleCountryChange={this.handleCountryChange}
                handleEmailChange={this.handleEmailChange}
                handleLastnameChange={this.handleLastnameChange}
                handleNameChange={this.handleNameChange}
                handleNeighborhoodChange={this.handleNeighborhoodChange}
                handleReservationOccupancy={this.handleReservationOccupancy}
                handlePhoneChange={this.handlePhoneChange}
                handlePoChange={this.handlePoChange}
                handleReservationTitle={this.handleReservationTitle}
                handleStateChange={this.handleStateChange}
                handleStreetChange={this.handleStreetChange}
                handleFacturaChange={this.handleFacturaChange}
                handlePaymentSubmit={this.handlePaymentSubmit}
                isPaying={this.state.isPaying}
                neighborhood={this.state.neighborhood}
                RoomBook={this.state.RoomBook}
                po={this.state.po}
                reservationOccupancy={this.state.reservationOccupancy}
                reservationTitle={this.state.reservationTitle}
                state={this.state.state}
                street={this.state.street}
                user={this.state.user}
                cowork={this.state.cowork}
                is_factura={this.state.is_factura} />
        );
    }

    renderSuccessDialog = () => {
        const center = this.state.center;
        if (!center) return null;
        return (
            <SuccessDialog centerName={this.state.center.name} />
        );
    }

    renderFacturasDialog = () => {
        return (
            <FacturasDialog />
        )
    }

    renderSummary = () => {
        return (
            <Summary
                center={this.state.center}
                RoomBook={this.state.RoomBook}
                paymentDetails={this.state.paymentDetails}
                count={this.state.sala}
            />
        );
    }

    renderSumaryCowork = () => {
        return (
            <SummaryCowork
                cowork={this.state.cowork}
                start_day={this.state.start_day}
                endDate={this.state.endDate}
                duracion_id={this.state.duracion_id}
                duracion={this.state.duracion}
                center={this.state.center}
                getTokenSession={this.props.getTokenSession}
                duracion_str={this.state.duracion_str}
                duracion_hora={this.state.duracion_hora}
                is_factura={this.state.is_factura}
            />
        );
    }

    renderSumaryDomicilio = () => {
        console.log(this.state);
        return (
            <SummaryDomicilio
                center={this.state.center}
                start_day={this.state.start_day_fomart}
                endDate={this.state.finsh_day_fomart}
                duracion_str={this.state.duracion_str}
                getTokenSession={this.props.getTokenSession}
            />
        );
    }

    rebderHelperContainer = () => {
        return (
            <HelpContainer />
        )
    }

    updateTimer = () => {
        this.setState({ showExtendModal: true })
        // var btn = document.getElementById('btnExtendBook');
        // btn.click();
        this.timer2 = setTimeout(() => {
            this.setState({ showExtendModal: false })
            this.handleError('Tu reservación ha expirado, por favor intenta de nuevo.');
        }, SECOND_TIMER)
    }

    handleExtendBook = () => {
        this.setState({ showExtendModal: false })
        clearTimeout(this.timer2)
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.updateTimer()
        }, FIRST_TIMER)
        // alert("Si")
        // Aqui extiendes la reservación
        this.extendReservation({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            reservation_id: this.props.match.params.reservationsid,
        });
    }

    handleCancel = () => {
        this.props.post_store(
            "/cancelReservation",
            {
                token_id: this.props.getTokenId(),
                token_session: '',
                reservation_id: this.props.match.params.reservationsid,
            },
            (response) => {
                console.log(response);
            },
            (error) => {
                console.warn(error);
            },
            null
        )
    }

    render() {
        const { t } = this.props;
        const ignoreModal = Boolean((this.props.location.state && this.props.location.state.isPayment2));
        // console.log(this.props.location)

        return (
            <React.Fragment>
                {
                    this.state.showExtendModal && !this.state.showModalBookExpired && (
                        <ExtendBookModal handleExtendBook={this.handleExtendBook} />
                    )
                }
                {
                    this.state.showModalBookExpired && (
                        <Dialog
                            title={t('venta_linea.modal.title_expired_book')}
                            handleDismiss={() => {
                                this.setState({ showModalBookExpired: false })
                                this.props.history.replace(URI_VENTA_EN_LINEA)
                            }}>
                            <p>{t('venta_linea.modal.description_expired_book')}</p>
                        </Dialog>
                    )
                }
                <div className="content-resvations">
                    <div className="container-resvations-title">
                        <GoBackButton
                            isPayment
                            ignoreModal={ignoreModal}
                            handleBack={this.handleCancel}
                        />
                        <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                    </div>
                    <div className="container-resvations">
                        <div className="row">
                            <div className="col-lg-5 col-lg-push-7">
                                {this.state.RoomBook ? this.renderSummary() : null}
                                {this.state.cowork && this.state.center ? this.renderSumaryCowork() : null}
                                {this.state.domicilioComercial && this.state.center ? this.renderSumaryDomicilio() : null}
                            </div>
                            <div className="col-lg-7 col-lg-pull-5">
                                {this.renderPayment()}
                                {this.renderSuccessDialog()}
                                {this.renderFacturasDialog()}
                            </div>
                        </div>
                    </div>
                    {this.rebderHelperContainer()}

                </div>
            </React.Fragment>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(PaymentContainer);



// WEBPACK FOOTER //
// ./src/store/Payment/PaymentContainer.js